import { useEffect, useState } from 'react';

export interface PriceInfo {
  amount: string;
  currency: 'ARS' | 'USD';
}

const ARS_PRICE: PriceInfo = {
  amount: 'ARS 21.990',
  currency: 'ARS'
};

const USD_PRICE: PriceInfo = {
  amount: 'USD 13.99',
  currency: 'USD'
};

/**
 * Detects the visitor country by IP with a free geolocation API.
 * Argentina -> ARS 21.990 · Rest of the world (or failure) -> USD 13.99
 */
export function useGeoPrice() {
  const [price, setPrice] = useState<PriceInfo>(USD_PRICE);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;

    const detectCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) throw new Error('Geolocation request failed');
        const data = await response.json();
        if (!active) return;
        setPrice(data?.country_code === 'AR' ? ARS_PRICE : USD_PRICE);
      } catch {
        if (active) setPrice(USD_PRICE);
      } finally {
        if (active) setIsLoading(false);
      }
    };

    detectCountry();

    return () => {
      active = false;
    };
  }, []);

  return {
    price,
    isLoading
  };
}
